const { formatText } = require('core/i18n').i18n;
const { sortByOrder } = require('lodash/collection');

const COUNTRY_CODES = [
    'AF',
    'AL',
    'DE',
    'AD',
    'AO',
    'AI',
    'AQ',
    'AG',
    'AN',
    'SA',
    'DZ',
    'AR',
    'AM',
    'AW',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BE',
    'BZ',
    'BJ',
    'BM',
    'BY',
    'BO',
    'BA',
    'BW',
    'BV',
    'BR',
    'BN',
    'BG',
    'BF',
    'BI',
    'BT',
    'KH',
    'CM',
    'CA',
    'TD',
    'CL',
    'CN',
    'CY',
    'VA',
    'CO',
    'KM',
    'CD',
    'CG',
    'KP',
    'KR',
    'CI',
    'CR',
    'HR',
    'CU',
    'DK',
    'DJ',
    'DM',
    'EC',
    'EG',
    'SV',
    'AE',
    'ER',
    'SK',
    'SI',
    'ES',
    'US',
    'EE',
    'ET',
    'FJ',
    'PH',
    'FI',
    'FR',
    'GA',
    'GM',
    'GJ',
    'GE',
    'GH',
    'GI',
    'GD',
    'GR',
    'GL',
    'GP',
    'GU',
    'GT',
    'GF',
    'GG',
    'GQ',
    'GW',
    'GN',
    'GY',
    'HT',
    'HN',
    'HK',
    'HU',
    'IN',
    'ID',
    'XU',
    'IR',
    'IQ',
    'IE',
    'UM',
    'IM',
    'NF',
    'IS',
    'KY',
    'CK',
    'CC',
    'FO',
    'HM',
    'FK',
    'MP',
    'CX',
    'TC',
    'VI',
    'VG',
    'IL',
    'IT',
    'JM',
    'JP',
    'JE',
    'JO',
    'KZ',
    'KE',
    'KG',
    'KI',
    'KW',
    'LA',
    'LS',
    'LV',
    'LB',
    'LR',
    'LY',
    'LI',
    'LT',
    'LU',
    'MO',
    'MK',
    'XM',
    'MG',
    'MY',
    'MW',
    'MV',
    'ML',
    'MT',
    'MA',
    'MH',
    'MQ',
    'MU',
    'MR',
    'YT',
    'MX',
    'FM',
    'MD',
    'MC',
    'MN',
    'MS',
    'MZ',
    'MM',
    'NA',
    'NR',
    'NP',
    'NI',
    'NE',
    'NG',
    'NU',
    'NO',
    'NC',
    'NZ',
    'XA',
    'XO',
    'XZ',
    'IO',
    'OM',
    'XI',
    'XN',
    'NL',
    'QU',
    'PK',
    'PW',
    'PA',
    'PG',
    'PY',
    'PE',
    'PN',
    'PF',
    'PL',
    'PT',
    'PR',
    'QA',
    'GB',
    'CF',
    'CZ',
    'CV',
    'ME',
    'RS',
    'ZR',
    'DO',
    'ZA',
    'RE',
    'RW',
    'RO',
    'RU',
    'EH',
    'SB',
    'AS',
    'WS',
    'KN',
    'SM',
    'PM',
    'VC',
    'SH',
    'LC',
    'ST',
    'SN',
    'CS',
    'SC',
    'SL',
    'SG',
    'SY',
    'SO',
    'LK',
    'SD',
    'SE',
    'CH',
    'GS',
    'SR',
    'SJ',
    'SZ',
    'TW',
    'TZ',
    'TJ',
    'PS',
    'TH',
    'TF',
    'TL',
    'TP',
    'TG',
    'TK',
    'TO',
    'TT',
    'TN',
    'TM',
    'TR',
    'TV',
    'UA',
    'UG',
    'UY',
    'UZ',
    'VU',
    'VE',
    'VN',
    'WK',
    'WF',
    'YE',
    'YU',
    'ZM',
    'ZW',
    'PZ',
    'NT'
]

const COUNTRIES_FLAGS = [
    'AU',
    'AT',
    'BE',
    'BR',
    'CA',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HK',
    'IE',
    'IT',
    'JP',
    'LU',
    'MX',
    'NO',
    'PL',
    'PT',
    'ES',
    'SE',
    'CH',
    'NL',
    'GB',
    'US'
]

const COUNTRY_PHONE_CODES = {
    ES: '34',
    PT: '351',
    DE: '49',
    FR: '33',
    NL: '31'
}

const getTranslatedCountry = code => formatText(`countries-${code}`);

const countryOptions = () => {
    return sortByOrder(COUNTRY_CODES.map(code => ({
            value: code,
            label: getTranslatedCountry(code)
        })),
        ['label'],
        ['asc']
    );
}

const countries = () => {
    let countriesMap = {};
    COUNTRY_CODES.forEach(code => {
        countriesMap[code] = getTranslatedCountry(code)
    });
    return countriesMap;
}

const COUNTRIES_CODES = COUNTRY_CODES.reduce((acc, current) => {
    acc[current] = current;
    return acc;
}, {})



module.exports = {
    COUNTRIES_CODES,
    COUNTRIES_FLAGS,
    COUNTRY_PHONE_CODES,
    DEFAULT_ORIGIN_COUNTRY: COUNTRIES_CODES.ES,
    getTranslatedCountry,
    countryOptions,
    countries
};
